<template>
  <div>
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="handleAdd"
      style="margin-bottom: 15px"
      >添加</el-button
    >
    <PageTable
      :columns="columns"
      :tableData="tableData"
      @page-change="handleChangePage"
    >
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            @click="handleEdit(row)"
            style="margin-right: 10px"
            >编辑</el-button
          >
          <el-popconfirm
            title="确定删除该联系人吗？"
            @confirm="handleDelete(row)"
          >
            <el-button slot="reference" type="text" class="colorRed"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </PageTable>

    <!-- 添加/编辑弹窗 -->
    <el-dialog
      :title="dialogType === 'add' ? '添加联系人' : '编辑联系人'"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
      @closed="handleDialogClosed"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="100px"
      >
        <el-form-item label="联系人：" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入联系人姓名"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input
            v-model="formData.email"
            placeholder="请输入联系人邮箱"
            maxlength="100"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageTable from "@/components/PageTable.vue";
import {
  getInspectionContactList,
  addInspectionContact,
  updateInspectionContact,
  deleteInspectionContact,
} from "./indexServe.js";

export default {
  name: "InspectionContact",
  components: { PageTable },
  data() {
    const checkEmail = (rule, value, callback) => {
      // 校验邮箱
      // eslint-disable-next-line no-useless-escape
      const patt = /^([a-zA-Z0-9_\.\-]+@([a-zA-Z0-9\-]+\.)+[a-z]+)$/;
      if (value && !patt.test(value)) {
        return callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    return {
      tableData: {
        list: [],
        page: 1,
        size: 10,
        total: 0,
      },
      columns: [
        {
          key: "name",
          label: "联系人",
          align: "center",
          "show-overflow-tooltip": true,
        },
        {
          key: "email",
          label: "邮箱",
          align: "center",
          "show-overflow-tooltip": true,
        },
        {
          key: "createTime",
          label: "创建日期",
          align: "center",
          "show-overflow-tooltip": true,
        },
        {
          key: "updateTime",
          label: "修改日期",
          align: "center",
          "show-overflow-tooltip": true,
        },
      ],
      dialogVisible: false,
      dialogType: "add", // add | edit
      formData: {
        id: null,
        name: "",
        email: "",
      },
      formRules: {
        name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { validator: checkEmail, trigger: ["blur", "change"] },
        ],
      },
    };
  },
  mounted() {
    this.getContactList();
  },
  methods: {
    // 获取联系人列表
    async getContactList(params = {}) {
      const data = {
        page: this.tableData.page,
        size: this.tableData.size,
        name: null,
        email: null,
        ...params,
      };
      const res = await getInspectionContactList(data);
      if (res && res.code === 0) {
        this.tableData = res.data;
      }
    },
    // 分页改变
    handleChangePage({ page, size }) {
      this.tableData.page = page;
      this.tableData.size = size;
      this.getContactList({ page, size });
    },
    // 添加
    handleAdd() {
      this.dialogType = "add";
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit(row) {
      this.dialogType = "edit";
      this.formData = {
        id: row.id,
        name: row.name,
        email: row.email,
      };
      this.dialogVisible = true;
    },
    // 删除
    async handleDelete(row) {
      const res = await deleteInspectionContact({ id: row.id });
      if (res && res.code === 0) {
        this.$message.success("删除成功");
        this.getContactList({
          page: this.tableData.page,
          size: this.tableData.size,
        });
      }
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const data = {
            name: this.formData.name,
            email: this.formData.email,
          };
          if (this.dialogType === "edit") {
            data.id = this.formData.id;
          }
          const fcn =
            this.dialogType === "add"
              ? addInspectionContact
              : updateInspectionContact;
          const res = await fcn(data);
          if (res && res.code === 0) {
            this.$message.success(
              this.dialogType === "add" ? "添加成功" : "编辑成功"
            );
            this.dialogVisible = false;
            this.getContactList({
              page: this.tableData.page,
              size: this.tableData.size,
            });
          }
        }
      });
    },
    // 弹窗关闭
    handleDialogClosed() {
      this.formData = {
        id: null,
        name: "",
        email: "",
      };
      this.$refs.formRef && this.$refs.formRef.resetFields();
    },
  },
};
</script>

<style scoped lang="scss"></style>
